interface HighlightTextProps {
  text: string;
  query: string;
}

export default function HighlightText({ text, query }: HighlightTextProps) {
  const keyword = query.trim();
  if (!keyword) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerKey = keyword.toLowerCase();
  const parts: Array<{ value: string; match: boolean }> = [];
  let index = 0;

  while (index < text.length) {
    const found = lowerText.indexOf(lowerKey, index);
    if (found === -1) {
      parts.push({ value: text.slice(index), match: false });
      break;
    }
    if (found > index) {
      parts.push({ value: text.slice(index, found), match: false });
    }
    parts.push({ value: text.slice(found, found + keyword.length), match: true });
    index = found + keyword.length;
  }

  return (
    <>
      {parts.map((part, i) =>
        part.match ? (
          <mark
            key={i}
            className="bg-accent-200/70 text-foreground-950 rounded-sm px-0.5"
          >
            {part.value}
          </mark>
        ) : (
          <span key={i}>{part.value}</span>
        )
      )}
    </>
  );
}